module.exports = __webpack_public_path__ + "img/Toolbox_icon.b82440d3.png";